import { buildCoreContactParameters } from '../buildCommonContactParameters'
import type { ContactSubscriptionData } from '../contactSubscriptionData'

type Parameters = {
  contactData: ContactSubscriptionData
  id: string | number
  country: string
  action: string
}

export const contactSaveParametersGeneration = ({
  contactData,
  id,
  country,
  action,
}: Parameters): URLSearchParams => {
  const options = buildCoreContactParameters({ contactData, id, country, action })

  const {
    personal: { bornCity = '' },
    professional: { siret, apeCode },
    identity: {
      documentType = '',
      documentNumber = '',
      expirationDate = '',
      createdDate = '',
      issuingEntity = '',
      issuingCity = '',
      taxIdCode = '',
    } = {},
  } = contactData

  options.append('pro_siret', siret || '')
  options.append('pro_ape_code', apeCode || '')

  if (bornCity) options.append('born_city', bornCity)

  if (documentType) options.append('identity_document_type', documentType)
  if (documentNumber) options.append('identity_document_number', documentNumber)
  if (expirationDate) options.append('identity_expiration_date', expirationDate)
  if (createdDate) options.append('identity_created_date', createdDate)
  if (issuingEntity) options.append('identity_issuing_entity', issuingEntity)
  if (issuingCity) options.append('identity_issuing_city', issuingCity)
  options.append('identity_tax_id_code', taxIdCode || '')

  return options
}
